import { Skeleton } from '@heroui/skeleton';
import type React from 'react';
import { useEffect, useState, useRef } from 'react';

export default function ImageLoader({
  src,
  className = 'size-full object-contain',
  alt = '',
  ...props
}: React.ImgHTMLAttributes<HTMLImageElement>) {
  const [isLoading, setIsLoading] = useState(true);
  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    if (imgRef.current?.complete && imgRef.current.naturalWidth !== 0) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const timeout = setTimeout(() => setIsLoading(false), 30000);

    return () => clearTimeout(timeout);
  }, [src]);

  const hideLoadingScreen = () => {
    setIsLoading(false);
  };

  return (
    <>
      {isLoading && (
        <Skeleton className={`absolute ${className}`}>
          <div className="size-full rounded-lg bg-default-300 dark:bg-grey-800"></div>
        </Skeleton>
      )}
      <img
        {...props}
        ref={imgRef}
        src={src}
        className={className}
        alt={alt}
        onLoad={hideLoadingScreen}
        onError={hideLoadingScreen}
      />
    </>
  );
}
